import { render, staticRenderFns } from "./guide-app.vue?vue&type=template&id=6b796858&scoped=true"
import script from "./guide-app.vue?vue&type=script&lang=js"
export * from "./guide-app.vue?vue&type=script&lang=js"
import style0 from "./guide-app.vue?vue&type=style&index=0&id=6b796858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b796858",
  null
  
)

export default component.exports